"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/icon/style"));
var _default = props => _react.default.createElement(_style.default, props, props.children);
exports.default = _default;